import { useState } from 'react';
import { Link } from 'react-router-dom';
import { movies, categories } from '@/mocks/data';
import MovieCard from '@/components/feature/MovieCard';

export default function HotMovies() {
  const [activeCategory, setActiveCategory] = useState('all');

  const filteredMovies = activeCategory === 'all'
    ? movies.slice(0, 8)
    : movies.filter((m) => m.category === activeCategory).slice(0, 8);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950">热门推荐</h2>
            <p className="text-sm text-foreground-600 mt-1">精选高分电影，实时更新</p>
          </div>
          <Link
            to="/category/dongzuo"
            className="text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200 flex items-center gap-1 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="flex flex-wrap items-center gap-2 mb-6">
          <button
            onClick={() => setActiveCategory('all')}
            className={`px-4 py-1.5 rounded-full text-xs font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
              activeCategory === 'all'
                ? 'bg-primary-500 text-white'
                : 'bg-background-50 text-foreground-600 border border-background-200 hover:border-primary-300'
            }`}
          >
            全部
          </button>
          {categories.slice(0, 6).map((cat) => (
            <button
              key={cat.slug}
              onClick={() => setActiveCategory(cat.slug)}
              className={`px-4 py-1.5 rounded-full text-xs font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                activeCategory === cat.slug
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-50 text-foreground-600 border border-background-200 hover:border-primary-300'
              }`}
            >
              {cat.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {filteredMovies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}